import { hot } from "react-hot-loader";

import RootProd from "./Root.prod";
import RootDev from "./Root.dev";

export default hot(module)(process.env.NODE_ENV === "production" ? RootProd : RootDev);
